import { useBrandCookie } from 'hooks/helpers/useBrandCookie'

export const useIsIshaPage = (): boolean => {
  return useBrandCookie('isIshaAddress')
}
